export const CollaborationsController = {
    index(): void {},
};
